import {RestService} from "@sinossi/mates-react-library";
import {Profile, UpdateProfileDetails} from "../models";

export class ProfileServices {
    static getProfile = (callback: any, catchCallback: any) => {
        RestService
            .get<Profile>("/api/account")
            .then(callback)
            .catch(catchCallback)
    }

    static putProfile = (request: UpdateProfileDetails, callback: any, catchCallback: any) => {
        RestService
            .put<any>("/api/account", request)
            .then(callback)
            .catch(catchCallback)
    }
}
